import { useMutation, useQuery } from '@tanstack/react-query';
import { legacyDocumentDetailSchema, legacyDocumentListSchema } from '@erp/shared';
import { apiDownload, apiFetch, saveBlob } from '@/lib/api-client';

export function useLegacyDocuments(query: string, enabled: boolean) {
  return useQuery({
    queryKey: ['legacy-documents', query],
    enabled,
    queryFn: () => apiFetch(`/api/v1/legacy-documents?${query}`, legacyDocumentListSchema),
  });
}
export function useLegacyDocument(id: string | undefined) {
  return useQuery({
    queryKey: ['legacy-document', id],
    enabled: id !== undefined,
    queryFn: () =>
      apiFetch(
        `/api/v1/legacy-documents/${encodeURIComponent(id ?? '')}`,
        legacyDocumentDetailSchema,
      ),
  });
}
export function useLegacyDownload(documentId: string) {
  return useMutation({
    mutationFn: async (artifact: { id: string; originalName: string }) => {
      saveBlob(
        await apiDownload(
          `/api/v1/legacy-documents/${encodeURIComponent(documentId)}/originals/${encodeURIComponent(artifact.id)}`,
          artifact.originalName,
        ),
      );
    },
  });
}
